(function () {
  const mql = window.matchMedia('(max-width: 999px)');
  const rows = document.querySelectorAll('.table-panel__row:not(.table-panel__row--header)');

  function openRow(row, toggle, details, inner) {
    row.classList.add('is-expanded');
    toggle.setAttribute('aria-expanded', 'true');
    details.style.height = inner.scrollHeight + 'px';
  }

  function closeRow(row, toggle, details) {
    details.style.height = details.scrollHeight + 'px';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        details.style.height = '0px';
      });
    });
    row.classList.remove('is-expanded');
    toggle.setAttribute('aria-expanded', 'false');
  }

  function resetRow(row, toggle, details) {
    row.classList.remove('is-expanded');
    toggle.setAttribute('aria-expanded', 'false');
    details.style.height = '';
  }

  rows.forEach((row) => {
    const toggle = row.querySelector('.table-panel__col--name');
    const details = row.querySelector('.table-panel__details');
    const inner = row.querySelector('.table-panel__details-inner');
    if (!toggle || !details || !inner) return;

    toggle.addEventListener('click', () => {
      if (!mql.matches) return;
      if (row.classList.contains('is-expanded')) {
        closeRow(row, toggle, details);
      } else {
        openRow(row, toggle, details, inner);
      }
    });
  });

  mql.addEventListener('change', (event) => {
    if (event.matches) return;
    rows.forEach((row) => {
      const toggle = row.querySelector('.table-panel__col--name');
      const details = row.querySelector('.table-panel__details');
      if (toggle && details) resetRow(row, toggle, details);
    });
  });

  window.addEventListener('resize', () => {
    if (!mql.matches) return;
    rows.forEach((row) => {
      if (!row.classList.contains('is-expanded')) return;
      const details = row.querySelector('.table-panel__details');
      const inner = row.querySelector('.table-panel__details-inner');
      if (details && inner) details.style.height = inner.scrollHeight + 'px';
    });
  });
})();
